module.exports = __webpack_public_path__ + "static/media/export.5f57898c.svg";